import useFetch from "./useFetch";
import {
  getVideoFiles,
} from "../api/files";

export const useGetVideoFiles = () => {
  const { data, error, loading, request } = useFetch(getVideoFiles);
  return { getVideoFiles: request, data:data||[], error, loading };
};
